<template>
  <div>
    <div v-if="showFile"
         class='file-container flex items-center justify-between text-base'
         :style="styles.file"
    >
      <div class="flex items-center">
        <span class='icon-file-message flex items-center w-5'>
          <img :src="file"/>
        </span>
        testingImage.png
      </div>
      <vs-icon class='delete-file-message text-xl font-bold not-italic float-right cursor-pointer' icon="close"
               :style="styles.fileIcon"/>
    </div>

    <div class="sc-user-input-wrapper powered-by-amio flex flex-col gap-4 p-4"
         :style="styles.wrapper"
    >
      <div class="flex w-full justify-between gap-4">
        <div class="sc-user-input m-0 relative bottom-0 flex w-full"
             :style="styles.input"
        >
          <div
            class="sc-user-input--text truncate flex-1 resize-none border-none outline-none py-2.5 pr-2.5 pl-4 text-base font-normal whitespace-pre-wrap antialiased overflow-scroll bottom-0 overflow-x-hidden overflow-y-auto"
            :style="styles.text">Write a message...
          </div>
          <div class="sc-user-input--buttons inline-flex justify-end pr-4">
            <div class="sc-user-input--button flex flex-col justify-center cursor-pointer">
              <div>
                <button type="button"
                        class="sc-user-input--file-icon-wrapper border-none bg-transparent p-0 m-0 outline-none cursor-pointer focus:outline-none"
                        :style="styles.text"
                >
                  <label for="file-input" class="file-input-button">
                    <attachment-icon/>
                  </label>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="sc-user-input--button flex flex-col justify-center cursor-pointer">
          <button
            class="sc-user-input--button-icon-wrapper sc-user-input--button-control cursor-pointer h-10 w-10 rounded-full border-none flex flex-col justify-center p-0 m-0 outline-none focus:outline-none"
            :style="styles.button"
          >
            <sentIcon :styles="styles"/>
          </button>
        </div>
      </div>
      <ChatFooter :theme-config="themeConfig" class="flex-1"/>
    </div>
  </div>
</template>

<script>
import file from '@/assets/images/icons/chat-widget/file.svg'
import attachmentIcon from '@/assets/images/icons/chat-widget/attachmentIcon.vue'
import sentIcon from '@/assets/images/icons/chat-widget/sentIcon.vue'
import ChatFooter from '@/components/settings/bot-theme/chat-widget/components/chat/ChatFooter.vue'

export default {
  name: 'ChatControls.vue',

  components: { ChatFooter, sentIcon, attachmentIcon },

  props: {
    themeConfig: {
      type: Object,
      required: true
    },
    showFile: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      file
    }
  },

  computed: {
    styles() {
      return {
        wrapper: {
          background: this.themeConfig.userInput.wrapperBg
        },
        input: {
          background: this.themeConfig.userInput.bg,
          fontFamily: this.themeConfig.font
        },
        text: {
          color: this.themeConfig.userInput.text
        },
        button: {
          background: this.themeConfig.userInput.sendButton
        },
        buttonText: {
          '--button-color': this.themeConfig.sentMessage.button.text,
          fill: this.themeConfig.userInput.sendIcon,
          '--button-color-hover': this.themeConfig.sentMessage.button.textHover
        },
        file: {
          backgroundColor: this.themeConfig.userInput.text,
          color: this.themeConfig.userInput.bg
        },
        fileIcon: {
          color: this.themeConfig.userInput.bg
        }
      }
    }
  }
}
</script>
